import { render } from "./MenuToggle.vue?vue&type=template&id=21fc0974&scoped=true"
import script from "./MenuToggle.vue?vue&type=script&lang=js"
export * from "./MenuToggle.vue?vue&type=script&lang=js"

import "./MenuToggle.vue?vue&type=style&index=0&id=21fc0974&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Murilo\\Documents\\app-construp-cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fc0974"]])

export default __exports__